import InviteForm from '@/Libs/Pages/Public/Employee/InviteForm.vue'

export default [
    {
        name: 'employee-invite',
        path: '/invite/employee/:id',
        component: InviteForm,
        meta: {
            title: 'employee.title.invite',
            permission: null
        },
    },
];